module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fAyGoP/tc-custom/9781512489002.jpg?1718162172148",
      "alt": "This image is the cover for the book Goodnight Sh'ma"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Goodnight Sh'ma\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("I say the Sh'ma and I feel God's light / Shining on me all through the night.")])])]), _c('p', [_vm._v("A Jewish child gets ready for bed and says the traditional \"Sh'ma\" prayer in this beautiful board book with rhyming text and charming illustrations by award-winning Melanie Hall.")]), _c('p', [_vm._v("Introduce young children to Jewish life, Jewish holidays, and Shabbat with Very First Board Books.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqueline Jules, Melanie Hall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Melanie Hall grew up in  Manchester-By-the-Sea, Massachusetts. She attended the Rhode Island School of Design and Pratt Institute, receiving her B.F.A. from Pratt Institute. She went on to earn her Master's Degree at Marywood University in Scranton, Pennsylvania, where she studied children's book illustration.  She is the illustrator of over twenty-five children's books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Karb-Ben\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0